import * as React from "react";
import { DockingRoot, DragGhost, useDragCtx } from "./docking.component.tsx";
import { DockingEditBar } from "./docking-edit-bar.component.tsx";

export function DockingShell() {
  const { drag } = useDragCtx();

  return (
    <>
      <DockingEditBar />
      <DockingRoot />
      {drag && (
        <div className="pointer-events-none absolute left-1/2 top-2 z-[100] -translate-x-1/2 rounded-[6px] bg-sf-text px-3.5 py-1.5 text-xs font-medium text-white shadow-[var(--sf-shadow-lg)]">
          Glissez sur un panneau ·{" "}
          <span className="opacity-70">centre = onglet · bord = scinder</span>
        </div>
      )}
      <DragGhost />
    </>
  );
}
